import React from 'react';
import { datejs, isEmpty, isObject } from '@block/utils';
import { Form, Icon, Input, Radio, DatePicker, Select, notification, Announcement } from '@block/plug';
import { SuccessFile } from '@src/types/self';
import { HoverText, Company } from '@src/components';
import { Works, OutOfWorks, Resume } from './elements';
import { Upload } from '../../components';
import { worksTemplate, outOfWorksTemplate } from './template';
import Url from './url';
import { doAction, getPattern, validateItems, compareDate } from '../../utils';
import init from './init';
import './index.scss';

const labelWidth = 260;
let worksKey = '';
let outOfWorksKey = '';
interface State {
  works: any[];
  outOfWorks: any[];
  worksRefs: any;
  outOfWorksRefs: any;
  resumeList: any[];
  hasSeparationProve: string;
  status: boolean;
  separationProveStatus: boolean;
  separationProveValue: string;
  ifUpgrade: boolean;
  showRefer: boolean;
  otherReasonStatus: boolean;
  competitionStatus: boolean; // 是否展示竞业开始时间  boolean代表不展示  false代表展示
  leaveReasonStatus: boolean;
  attrsStatus: boolean;
}
class WorkInfo extends React.Component<{}, State> {
  dataChanged: boolean;

  itemRef: React.RefObject<any>;

  lastJobRef: React.RefObject<any>;

  constructor(props) {
    super(props);
    this.state = {
      status: true, // true 标识隐藏除了是否是第一份工作的所有字段  false代表展示
      separationProveValue: '', // 离职证明的值
      works: [],
      outOfWorks: [],
      resumeList: [],
      worksRefs: [], // 放置works的ref
      outOfWorksRefs: [], // 放置outOfWorks的ref
      separationProveStatus: false,
      hasSeparationProve: 'Y',
      otherReasonStatus: false,
      competitionStatus: true, // 是否展示竞业开始时间  true代表不展示  false代表展示
      leaveReasonStatus: true,
      attrsStatus: true,
      ifUpgrade: false, // 是否升级背调
      showRefer: false, // 是否展示更多证明人
    };
    this.dataChanged = false;
    this.itemRef = React.createRef();
    this.lastJobRef = React.createRef();
  }

  async componentDidMount() {
    const data = (await doAction(Url.getInfo, {}, null)) || {};
    let workerTypeData = {};
    const status = window.checkTypeValue === 'entry';
    if (status) {
      workerTypeData = await doAction(Url.getWorkType, {}, null);
    }
    const {
      isFirstJob,
      works = [],
      outOfWorks = [],
      hasCompetitionAgreement,
      resumeList,
      hasSeparationProve,
      leaveReasonIndex,
      endDate,
      ifUpgrade,
    } = data;
    const lastJobRef = this.lastJobRef.current;
    this.itemRef.current?.setFieldsValue(data);
    lastJobRef?.setFieldsValue(data);

    let stateObj = {};

    stateObj = { ...this.handleAdapterFirstJob(isFirstJob, workerTypeData) };

    if (hasCompetitionAgreement === 1) {
      // 是否展示竞业时间
      stateObj = { ...stateObj, competitionStatus: false };
    }
    const period = !endDate || datejs(new Date().getTime()).diff(datejs(endDate), 'month') > 60;
    stateObj = { ...stateObj, attrsStatus: period };

    stateObj = { ...stateObj, ...this.handleSetNoProveReason(hasSeparationProve, data) };

    this.setState(
      {
        ifUpgrade,
        works,
        outOfWorks,
        resumeList,
        leaveReasonStatus: leaveReasonIndex !== 101,
        ...stateObj,
      },
      () => {
        const { noProveReasonIndex, noProveReason } = data;
        // 如果无法取得离职证明原因为其他
        const noProveReasonIndexFlag = noProveReasonIndex === 4;
        const tempObj = lastJobRef.getFieldsValueIncludeHide();
        tempObj.noProveReason = noProveReasonIndexFlag ? '其他' : noProveReason;
        tempObj.noProveReasonIndex = { id: noProveReasonIndex, descr: noProveReasonIndexFlag ? '其他' : noProveReason };
        tempObj.otherReason = noProveReasonIndexFlag ? noProveReason : null;
        lastJobRef?.setFieldsValue(tempObj);
      },
    );
  }

  // isFirstJob字段涉及的逻辑
  handleAdapterFirstJob = (value, workerTypeData) => {
    let stateObj = {};
    if (value === 0) {
      stateObj = { status: false };
    }
    if (value !== 0 && !value) {
      const isFirstJob = workerTypeData.workerType === 'RI' ? 1 : 0;
      this.itemRef.current?.setFieldsValue({ isFirstJob });
      stateObj = { status: isFirstJob === 1 };
    }
    return stateObj;
  };

  // 适配无法取得离职证明参数
  handleSetNoProveReason = (value, data) => {
    const { hasProveBeforeDatatime, noProveReasonIndex } = data;
    let stateObj = {};
    if (value === 'N') {
      const val = `N-${hasProveBeforeDatatime}`;
      this.lastJobRef.current?.setFieldsValue({
        hasSeparationProve: val,
      });
      stateObj = {
        separationProveStatus: true,
        hasSeparationProve: 'N',
        separationProveValue: val,
        otherReasonStatus: noProveReasonIndex === 4,
      };
    } else if (value === 'Y') {
      stateObj = {
        separationProveStatus: false,
        hasSeparationProve: 'Y',
        separationProveValue: 'Y',
        otherReasonStatus: false,
      };
    } else {
      stateObj = {
        separationProveStatus: true,
        hasSeparationProve: null,
        separationProveValue: '',
        otherReasonStatus: false,
      };
    }
    return stateObj;
  };

  // 获取无法取得离职证明的原因
  handleFetchNoProveReasonList = async (filter = '') => {
    const data = await doAction(Url.getNoProveReasons, { filter }, null);
    return data;
  };

  handleWorksChange = (data, index) => {
    const { works } = this.state;
    const tempData = works.map((item, i) => {
      if (index === i) {
        item = data;
      }
      return item;
    });
    this.setState({ works: tempData });
  };

  handleOutOfWorksChange = (data, index) => {
    const { outOfWorks } = this.state;
    const tempData = outOfWorks.map((item, i) => {
      if (index === i) {
        item = data;
      }
      return item;
    });
    this.setState({ outOfWorks: tempData });
  };

  handleFetchRef = (type, ref) => {
    const { worksRefs, outOfWorksRefs } = this.state;
    if (type === 'works') worksRefs.push(ref);
    if (type === 'outOfWorks') outOfWorksRefs.push(ref);
    this.setState({
      worksRefs,
      outOfWorksRefs,
    });
  };

  handleAdd = (type) => {
    const { works, outOfWorks } = this.state;
    if (type === 'works') works.push(worksTemplate);
    if (type === 'outOfWorks') outOfWorks.push(outOfWorksTemplate);
    this.setState({ works, outOfWorks });
  };

  // 保存
  handleSave = async () => {
    const ref = this.itemRef.current;
    const lastRef = this.lastJobRef.current;
    const { worksRefs, outOfWorksRefs, resumeList } = this.state;
    if (
      ref?.validateFields() &&
      lastRef?.validateFields() &&
      validateItems(worksRefs) &&
      validateItems(outOfWorksRefs)
    ) {
      // 未传附件
      if (window.checkTypeIndex !== 0 && resumeList && resumeList.length === 0) {
        notification.warning({
          title: '提示',
          message: '请上传最新工作简历',
        });
        return false;
      }
      const finalData = this.handleFetchFinalData();
      const res = await doAction(Url.validate, finalData);
      if (res === false) return false;
      const { result, message, type, dateTimes } = res;
      if (!result) {
        if (type === 'outOfBusiness') {
          this.handleChangeOutOfWorks(dateTimes);
        }
        notification.warning({
          title: '提示',
          message,
        });
        return result;
      }
      const data = await doAction(Url.save, finalData);
      return data === undefined ? false : data;
    }
    notification.warning({
      title: '提示',
      message: '请完善信息',
    });
    return false;
  };

  handleChangeOutOfWorks = (dateTimes) => {
    const { outOfWorks } = this.state;
    dateTimes.forEach((item) => {
      const { startTime, endTime } = item;
      outOfWorks.push({ ...outOfWorksTemplate, startDate: startTime, endDate: endTime });
    });
    this.setState({ outOfWorks });
  };

  handleUpload = (file) => {
    this.setState({
      resumeList: file,
    });
    this.dataChanged = true;
  };

  // 获取最终组织数据
  handleFetchFinalData = () => {
    const formData = this.lastJobRef.current.getFieldsValueIncludeHide();
    const { isFirstJob, firstJobDate, firstJobDateStr, jobOffMonth } = this.itemRef.current.getFieldsValueIncludeHide();
    const { hasSeparationProve, works, outOfWorks, resumeList } = this.state;
    const filterArr = ['works', 'outOfWorks']; // 因为getFieldsValueIncludeHide里面有works 和 outOfWorks两个字段, 需要剔除, 不然会覆盖worksData
    if (isFirstJob === 0 && formData.hasDismissCompetitionAgree === 0) {
      filterArr.concat(['competitionAgreeCompany', 'competitionAgreeStartDate', 'competitionAgreeEndDate']);
    }
    const tempData: any = {};
    const keyList = Object.keys(formData);
    for (let i = 0; i < keyList.length; i += 1) {
      const key = keyList[i];
      if (filterArr.indexOf(key) === -1) {
        tempData[key] = formData[key];
      }
    }

    if (tempData.noProveReasonIndex && isObject(tempData.noProveReasonIndex)) {
      tempData.noProveReasonIndex = null;
    }
    // 如果无法取得离职证明原因为其他
    if (tempData.noProveReasonIndex === 4) {
      tempData.noProveReason = tempData.otherReason;
    }
    if (tempData.hasSeparationProve === 'N-N' || tempData.hasSeparationProve === 'N-Y') {
      if (tempData.hasSeparationProve === 'N-Y') {
        tempData.noProveReason = null;
        tempData.noProveReasonIndex = null;
      }
    }
    if (tempData.hasSeparationProve === 'Y') {
      tempData.hasProveBeforeDatatime = null;
      tempData.noProveReason = null;
      tempData.noProveReasonIndex = null;
    }

    if (isFirstJob === 1) {
      return { ...init, outOfWorks, resumeList };
    }
    const finalData = {
      ...tempData,
      hasSeparationProve,
      isFirstJob,
      firstJobDate,
      firstJobDateStr,
      jobOffMonth,
      works,
      outOfWorks,
      resumeList,
    };
    return finalData;
  };

  // 首次工作经历
  handleFirstFieldValueChange = (code, value) => {
    if (code === 'isFirstJob') {
      this.itemRef.current && this.itemRef.current.clearValidateStatus();
      this.lastJobRef.current && this.lastJobRef.current.clearValidateStatus();
      this.setState({ status: value === 1 });
      // 如果formItemValue为0, 则是否已拿到离职证明设置已取得
      const { hasSeparationProve } = this.lastJobRef.current.getFieldsValueIncludeHide();
      if (value === 0 && !hasSeparationProve) {
        this.lastJobRef.current?.setFieldsValue({
          hasSeparationProve: 'Y',
          hasProveBeforeDatatime: null,
        });
        this.setState({
          hasSeparationProve: 'Y',
          separationProveStatus: false,
          separationProveValue: 'Y',
        });
      }
      // this.setState({ separationProveStatus: true });
    }
    if (code === 'firstJobDate') {
      this.itemRef.current?.setFieldsValue({
        firstJobDateStr: datejs(value).format('YYYY-MM-DD'),
      });
    }
    this.dataChanged = true;
  };

  handleFieldValueChange = (code, value, fieldsValue) => {
    const ref = this.lastJobRef.current;
    const { ifUpgrade } = this.state;
    if (code === 'endDate') {
      const date = new Date();
      const currentYear = date.getFullYear();
      const currentMonth = date.getMonth();
      const endDateYear = datejs(value).year();
      const endDateMonth = datejs(value).month();
      if (ifUpgrade) {
        if (currentYear - endDateYear < 5 || (currentYear - endDateYear === 5 && currentMonth <= endDateMonth)) {
          this.setState({
            showRefer: false,
          });
        } else {
          this.setState({
            showRefer: true,
          });
        }
      }
    }
    if (code === 'hasSeparationProve') {
      if (value.indexOf('N') > -1) {
        ref?.setFieldsValue({
          hasProveBeforeDatatime: value.split('-')[1],
          separationProveUrl: null,
          separationProveId: null,
          separationProveName: null,
        });
        this.setState({
          separationProveStatus: true,
          hasSeparationProve: 'N',
          separationProveValue: value,
          otherReasonStatus: false,
        });
      } else {
        ref?.setFieldsValue({
          hasProveBeforeDatatime: null,
        });
        this.setState({
          separationProveStatus: false,
          hasSeparationProve: 'Y',
          separationProveValue: value,
          otherReasonStatus: false,
        });
      }
      ref?.setFieldsValue({
        noProveReasonIndex: null,
        noProveReason: '',
      });
    }
    if (code === 'hasCompetitionAgreement') {
      this.setState({ competitionStatus: value !== 1 });
    }
    if (code === 'competitionAgreeStartDate') {
      const { competitionAgreeEndDate } = ref.getFieldsValueIncludeHide();
      if (compareDate(value, competitionAgreeEndDate)) {
        ref.clearValidateStatus(['competitionAgreeEndDate']);
      } else {
        ref?.validateFields(['competitionAgreeEndDate']);
      }
      ref?.setFieldsValue({
        competitionAgreeStartDateStr: value ? datejs(value).format('YYYY-MM-DD') : null,
      });
    }
    if (code === 'competitionAgreeEndDate') {
      ref?.setFieldsValue({
        competitionAgreeEndDateStr: value ? datejs(value).format('YYYY-MM-DD') : null,
      });
    }
    if (code === 'noProveReasonIndex') {
      this.setState({ otherReasonStatus: value === 4 });
      if (value !== 4) {
        ref?.setFieldsValue({ otherReason: null });
      }
    }
    if (code === 'leaveReasonIndex') {
      this.setState({
        leaveReasonStatus: value !== 101,
      });
      ref?.setFieldsValue({
        leaveReasonValue: fieldsValue.leaveReasonValue,
      });
    }
    if (code === 'startDate') {
      const startDate = value ? datejs(value).set('date', 1).valueOf() : null;
      const startDateStr = value ? datejs(value).set('date', 1).format('YYYY-MM-DD') : null;
      ref?.setFieldsValue({
        startDate,
        startDateStr,
      });
      const { endDate } = ref.getFieldsValueIncludeHide();
      if (compareDate(value, endDate)) {
        ref.clearValidateStatus(['endDate']);
      } else {
        ref?.validateFields(['endDate']);
      }
    }
    if (code === 'endDate') {
      const endDate = value ? datejs(value).set('date', 1).valueOf() : null;
      const endDateStr = value ? datejs(value).set('date', 1).format('YYYY-MM-DD') : null;
      ref?.setFieldsValue({
        endDate,
        endDateStr,
      });
      const period = !value || datejs(new Date().getTime()).diff(datejs(value), 'month') > 60;
      this.setState({ attrsStatus: period });
    }
    this.dataChanged = true;
  };

  handleSuccess = (file) => {
    const fileObj = file || {};
    const { fileId, fileName, fileUrl } = (fileObj.fileInfo as SuccessFile) || {};
    const ref = this.lastJobRef.current;
    ref?.setFieldsValue({
      separationProveUrl: fileUrl,
      separationProveId: fileId,
      separationProveName: fileName,
    });
    this.dataChanged = true;
    fileId && ref.clearValidateStatus(['separationProveUrl']);
  };

  handleDelete = (type, index) => {
    const { works, outOfWorks } = this.state;
    if (type === 'works') works.splice(index, 1);
    if (type === 'outOfWorks') outOfWorks.splice(index, 1);
    this.dataChanged = true;
    worksKey = worksKey === '' ? ' ' : '';
    outOfWorksKey = outOfWorksKey === '' ? ' ' : '';
    this.setState({ works, outOfWorks });
  };

  handleFetchData = async (filter = '', type = undefined) => {
    let url = '';
    if (type === 'nationality') {
      // 国家
      url = Url.getNationality;
    }
    if (type === 'leave') {
      // 离职原因
      url = Url.getLeaveReasons;
      const data = await doAction(url, {
        filter,
      });
      return data;
    }
    const data = await doAction(url, {
      filter,
    });
    return data.pageList;
  };

  // 第一次工作信息
  renderFirstJob = () => {
    const { status } = this.state;
    return (
      <Form
        ref={this.itemRef}
        labelWidth="20em"
        onFieldValueChange={this.handleFirstFieldValueChange}
        className="first__form"
      >
        <Form.Item labelWidth={0}>
          <span className="base-form__title">首次工作经历</span>
        </Form.Item>
        <Form.Item
          formItemKey="isFirstJob"
          span={20}
          required
          label={
            <HoverText message="正式工作指签订劳动合同的工作，不含实习经历。" extra="：">
              本次入职是否为第一份正式工作
            </HoverText>
          }
        >
          <Radio.Group toFormItem>
            <Radio value={1}>是</Radio>
            <Radio value={0}>否</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          formItemKey="firstJobDate"
          span={12}
          label={
            <HoverText message="必须晚于第一份全日制学历毕业日期，将用于社会工龄的计算等，请准确填写" extra="：">
              第一份正式工作开始日期
            </HoverText>
          }
          required
          hide={status}
          message="不能为空"
        >
          <DatePicker
            toFormItem
            valueFormat="timestamp"
            popLayer={{
              getContainer: () => document.querySelector('.first__form'),
            }}
          />
        </Form.Item>
        <Form.Item labelWidth={0}>
          <div className="base-form__dividing" />
        </Form.Item>
      </Form>
    );
  };

  // 最近工作信息
  renderLastJob = () => {
    const {
      status,
      separationProveStatus,
      competitionStatus,
      separationProveValue,
      otherReasonStatus,
      leaveReasonStatus,
      attrsStatus,
      showRefer,
    } = this.state;
    const notNeedCheck = window.checkTypeIndex === 0;
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    return (
      <Form
        ref={this.lastJobRef}
        labelWidth="120px"
        onFieldValueChange={this.handleFieldValueChange}
        className="last__form"
        style={{ display: status ? 'none' : '' }}
      >
        <Form.Item labelWidth={0} hide={status}>
          <span className="base-form__title">最近工作经历</span>
        </Form.Item>
        <Form.Item
          formItemKey="hasSeparationProve"
          span={24}
          hide={status}
          required
          message="不能为空"
          label="离职证明："
        >
          <Radio.Group toFormItem>
            <Radio value="Y">已取得离职证明</Radio>
            <Radio value="N-Y">暂未拿到, 入职当天可提供</Radio>
            <Radio value="N-N">入职当天仍无法提供离职证明</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          formItemKey="noProveReasonIndex"
          labelInValue={false}
          formItemLabel="noProveReason"
          span={11}
          hide={status || separationProveValue !== 'N-N'}
          label="详细原因："
          required
          message="不能为空"
        >
          <Select
            toFormItem
            filterable
            keyField="id"
            labelField="descr"
            onFetchData={(filter) => this.handleFetchNoProveReasonList(filter)}
            placeholder="请选择"
            loadingMessage="正在搜索..."
            notFoundMessage="无数据"
            popLayer={{
              getContainer: () => document.querySelector('.last__form'),
            }}
          />
        </Form.Item>
        <Form.Item span={10} labelWidth={0} hide={status || separationProveValue !== 'N-N' || otherReasonStatus} />
        <Form.Item
          formItemKey="otherReason"
          span={11}
          offset={2}
          label="补充说明："
          hide={status || !otherReasonStatus}
          required
          message="不能为空"
        >
          <Input toFormItem />
        </Form.Item>
        <Form.Item
          formItemKey="separationProveUrl"
          labelWidth={0}
          style={{
            paddingLeft: `${labelWidth}px`,
          }}
          required
          message="不能为空"
          hide={status || separationProveStatus}
        >
          <Upload
            toFormItem
            url={Url.ocrUpLoad}
            onParseUrlFromResponse={(res) => {
              const fileInfo = res.fileInfo || {};
              return fileInfo.fileUrl;
            }}
            onChange={(file: SuccessFile) => this.handleSuccess(file)}
          />
        </Form.Item>
        <Form.Item
          formItemKey="company"
          span={11}
          label={
            <HoverText message="请填写劳动合同/离职证明上的公司名称，请勿填写简称、俗称。" extra="：">
              公司名称
            </HoverText>
          }
          required
          hide={status}
          message="不能为空"
          rules={[
            { required: true, message: '不能为空' },
            {
              validator(rule, value, callback) {
                if (value && value.length > 50) {
                  callback('字数过长');
                } else {
                  callback();
                }
              },
            },
          ]}
        >
          <Company toFormItem />
        </Form.Item>
        <Form.Item
          formItemKey="companyAreaDict"
          labelInValue={false}
          formItemLabel="companyAreaName"
          offset={2}
          span={11}
          required
          hide={status}
          message="不能为空"
          label="工作国家/地区："
        >
          <Select
            toFormItem
            filterable
            keyField="dictIndex"
            labelField="dictValue"
            onFetchData={(filter) => this.handleFetchData(filter, 'nationality')}
            placeholder="请选择"
            loadingMessage="正在搜索..."
            notFoundMessage="无数据"
            popLayer={{
              getContainer: () => document.querySelector('.last__form'),
            }}
          />
        </Form.Item>
        <Form.Item
          formItemKey="position"
          span={11}
          label="职位："
          hide={status}
          rules={[
            { required: true, message: '不能为空' },
            {
              validator(rule, value, callback) {
                if (value && value.length > 30) {
                  callback('字数过长');
                } else {
                  callback();
                }
              },
            },
          ]}
        >
          <Input toFormItem maxLength={50} />
        </Form.Item>
        <Form.Item
          formItemKey="rank"
          span={11}
          offset={2}
          label="职级："
          required
          hide={status}
          message="不能为空"
          rules={[
            { required: true, message: '不能为空' },
            {
              validator(rule, value, callback) {
                if (value && value.length > 50) {
                  callback('字数过长');
                } else {
                  callback();
                }
              },
            },
          ]}
        >
          <Input toFormItem placeholder='没有或忘记，请填"无"' maxLength={70} />
        </Form.Item>

        <Form.Item formItemKey="startDate" span={7} label="工作起止时间：" required hide={status} message="不能为空">
          <span className="base-form__flex">
            <DatePicker
              toFormItem
              valueFormat="timestamp"
              format="YYYY-MM"
              placeholder="开始时间"
              popLayer={{
                getContainer: () => document.querySelector('.last__form'),
              }}
            />
            <span className="base-form__line" />
          </span>
        </Form.Item>
        <Form.Item
          className="base-form__space"
          formItemKey="endDate"
          span={4}
          labelWidth={0}
          hide={status}
          rules={[
            { required: true, message: '不能为空' },
            {
              validator(rule, value, callback) {
                const { startDate } = self.lastJobRef.current.getFieldsValueIncludeHide();
                const endDate = datejs(value).toDate().getTime();
                if (startDate && endDate < datejs(startDate).toDate().getTime()) {
                  callback('结束时间不能小于开始时间');
                } else {
                  callback();
                }
              },
            },
          ]}
        >
          <DatePicker
            toFormItem
            valueFormat="timestamp"
            format="YYYY-MM"
            placeholder="结束时间"
            popLayer={{
              getContainer: () => document.querySelector('.last__form'),
            }}
          />
        </Form.Item>
        <Form.Item
          formItemKey="hasBreakRules"
          span={11}
          offset={2}
          required
          hide={status}
          message="不能为空"
          label="有无违纪记录："
        >
          <Input toFormItem maxLength={50} placeholder='没有请填"无"' />
        </Form.Item>

        <Form.Item
          formItemKey="leaveReasonIndex"
          labelInValue={false}
          formItemLabel="leaveReasonValue"
          span={11}
          required
          message="不能为空"
          label="离职原因："
          hide={status}
        >
          <Select
            toFormItem
            filterable
            keyField="id"
            labelField="descr"
            onFetchData={(filter) => this.handleFetchData(filter, 'leave')}
            placeholder="请选择"
            loadingMessage="正在搜索..."
            notFoundMessage="无数据"
            popLayer={{
              getContainer: () => document.querySelector('.last__form'),
            }}
          />
        </Form.Item>
        <Form.Item
          formItemKey="leaveReasonOther"
          span={11}
          offset={2}
          label="原因说明："
          hide={status || leaveReasonStatus}
          rules={[
            { required: true, message: '不能为空' },
            {
              validator(rule, value, callback) {
                const pattern = getPattern('(^(?!\\s*$))[\\s\\S]{1,100}?$');
                if (pattern && !pattern.test(value)) {
                  callback('请输入1~100个字符');
                } else if (isEmpty(value)) {
                  callback('不能为空');
                } else {
                  callback();
                }
              },
            },
          ]}
        >
          <Input toFormItem maxLength={50} />
        </Form.Item>
        <Form.Item span={11} offset={2} hide={!status && !leaveReasonStatus} />

        <Form.Item
          formItemKey="hasDismissLaborRelation"
          span={11}
          hide={status}
          label="入职时是否与原单位解除劳动关系？"
          labelWidth="270px"
          required
          message="不能为空"
        >
          <Radio.Group toFormItem>
            <Radio value={1}>是</Radio>
            <Radio value={0}>否</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          formItemKey="hasCompetitionAgreement"
          span={11}
          offset={2}
          label="入职时是否与原单位存在竞业禁止协议？"
          labelWidth="270px"
          required
          hide={status}
          message="不能为空"
        >
          <Radio.Group toFormItem>
            <Radio value={1}>是</Radio>
            <Radio value={0}>否</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          formItemKey="competitionAgreeStartDate"
          span={7}
          label="竞业起止时间："
          hide={status || competitionStatus}
          required
          message="不能为空"
        >
          <span className="base-form__flex">
            <DatePicker
              toFormItem
              format="YYYY-MM"
              valueFormat="timestamp"
              placeholder="开始时间"
              popLayer={{
                getContainer: () => document.querySelector('.last__form'),
              }}
            />
            <span className="base-form__line" />
          </span>
        </Form.Item>
        <Form.Item
          formItemKey="competitionAgreeEndDate"
          span={4}
          labelWidth={0}
          hide={status || competitionStatus}
          rules={[
            { required: true, message: '不能为空' },
            {
              validator(rule, value, callback) {
                const { startDate } = self.lastJobRef.current.getFieldsValueIncludeHide();
                const endDate = datejs(value).toDate().getTime();
                if (startDate && endDate < datejs(startDate).toDate().getTime()) {
                  callback('结束时间不能小于开始时间');
                } else {
                  callback();
                }
              },
            },
          ]}
        >
          <DatePicker
            toFormItem
            format="YYYY-MM"
            valueFormat="timestamp"
            placeholder="结束时间"
            popLayer={{
              getContainer: () => document.querySelector('.last__form'),
            }}
          />
        </Form.Item>
        <Form.Item labelWidth={0} hide={showRefer || attrsStatus || status || notNeedCheck}>
          <span className="base-form__subtitle">
            人事部证明人
            <span className="base-form__desc">（请务必提供人事部在职在岗同事）</span>
          </span>
        </Form.Item>
        <Form.Item
          formItemKey="hrWitnessName"
          span={11}
          labelWidth="120px"
          label="姓名："
          hide={showRefer || attrsStatus || status || notNeedCheck}
          rules={[
            { required: true, message: '不能为空' },
            {
              validator(rule, value, callback) {
                if (value && value.length > 30) {
                  callback('字数过长');
                } else {
                  callback();
                }
              },
            },
          ]}
        >
          <Input toFormItem maxLength={50} />
        </Form.Item>
        <Form.Item
          formItemKey="hrWitnessPhone"
          span={11}
          label="手机号："
          labelWidth="120px"
          offset={2}
          hide={showRefer || attrsStatus || status || notNeedCheck}
          rules={[
            { required: true, message: '不能为空' },
            {
              validator(rule, value, callback) {
                const pattern = getPattern('^([0-9]{3,24})$');
                if (value && value.length > 24) {
                  callback('字数过长');
                } else if (pattern && !pattern.test(value)) {
                  callback('请输入有效的手机号');
                } else {
                  callback();
                }
              },
            },
          ]}
        >
          <Input toFormItem maxLength={50} />
        </Form.Item>
        <Form.Item
          formItemKey="hrWitnessPosition"
          span={11}
          hide={showRefer || attrsStatus || status || notNeedCheck}
          label="职位："
          labelWidth="120px"
          rules={[
            { required: true, message: '不能为空' },
            {
              validator(rule, value, callback) {
                if (value && value.length > 30) {
                  callback('字数过长');
                } else {
                  callback();
                }
              },
            },
          ]}
        >
          <Input toFormItem maxLength={50} />
        </Form.Item>

        <Form.Item labelWidth={0} hide={showRefer || attrsStatus || status || notNeedCheck}>
          <span className="base-form__subtitle">
            直接主管证明人
            <span className="base-form__desc">（请务必提供您在该公司的最后一任上级）</span>
          </span>
        </Form.Item>
        <Form.Item
          formItemKey="managerWitnessName"
          span={11}
          labelWidth="120px"
          label="姓名："
          hide={showRefer || attrsStatus || status || notNeedCheck}
          rules={[
            { required: true, message: '不能为空' },
            {
              validator(rule, value, callback) {
                if (value && value.length > 30) {
                  callback('字数过长');
                } else {
                  callback();
                }
              },
            },
          ]}
        >
          <Input toFormItem maxLength={50} />
        </Form.Item>
        <Form.Item
          formItemKey="managerWitnessPhone"
          labelWidth="120px"
          span={11}
          offset={2}
          hide={showRefer || attrsStatus || status || notNeedCheck}
          label="手机号："
          rules={[
            { required: true, message: '不能为空' },
            {
              validator(rule, value, callback) {
                const pattern = getPattern('^([0-9]{3,24})$');
                if (value && value.length > 24) {
                  callback('字数过长');
                } else if (pattern && !pattern.test(value)) {
                  callback('请输入有效的手机号');
                } else {
                  callback();
                }
              },
            },
          ]}
        >
          <Input toFormItem maxLength={50} />
        </Form.Item>
        <Form.Item
          formItemKey="managerWitnessPosition"
          span={11}
          labelWidth="120px"
          hide={showRefer || attrsStatus || status || notNeedCheck}
          label="职位："
          rules={[
            { required: true, message: '不能为空' },
            {
              validator(rule, value, callback) {
                if (value && value.length > 30) {
                  callback('字数过长');
                } else {
                  callback();
                }
              },
            },
          ]}
        >
          <Input toFormItem maxLength={50} />
        </Form.Item>
        <Form.Item labelWidth={0} hide={status}>
          <span className="base-form__subtitle">同事证明人</span>
        </Form.Item>
        <Form.Item
          formItemKey="witnessName"
          span={11}
          hide={status}
          labelWidth="120px"
          label="姓名："
          rules={[
            { required: true, message: '不能为空' },
            {
              validator(rule, value, callback) {
                if (value && value.length > 30) {
                  callback('字数过长');
                } else {
                  callback();
                }
              },
            },
          ]}
        >
          <Input toFormItem maxLength={50} />
        </Form.Item>
        <Form.Item
          formItemKey="witnessPhone"
          span={11}
          label="手机号："
          labelWidth="120px"
          offset={2}
          hide={status}
          rules={[
            { required: true, message: '不能为空' },
            {
              validator(rule, value, callback) {
                const pattern = getPattern('^([0-9]{3,24})$');
                if (value && value.length > 24) {
                  callback('字数过长');
                } else if (pattern && !pattern.test(value)) {
                  callback('请输入有效的手机号');
                } else {
                  callback();
                }
              },
            },
          ]}
        >
          <Input toFormItem maxLength={50} />
        </Form.Item>
        <Form.Item
          formItemKey="witnessPosition"
          span={11}
          label="职位："
          labelWidth="120px"
          hide={status}
          rules={[
            { required: true, message: '不能为空' },
            {
              validator(rule, value, callback) {
                if (value && value.length > 30) {
                  callback('字数过长');
                } else {
                  callback();
                }
              },
            },
          ]}
        >
          <Input toFormItem maxLength={50} />
        </Form.Item>
        <Form.Item span={11} />

        <Form.Item labelWidth={0} hide={status || competitionStatus}>
          <div className="base-form__dividing" />
        </Form.Item>
      </Form>
    );
  };

  // 渲染工作经历和歇业经历
  renderWorks = () => {
    const { works, ifUpgrade, showRefer } = this.state;
    if (!works) return null;
    return works.map((item, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <React.Fragment key={worksKey + index}>
        <Works
          data={item}
          ifUpgrade={ifUpgrade}
          index={index}
          showRefer={showRefer}
          getRef={(ref) => this.handleFetchRef('works', ref)}
          onChange={this.handleWorksChange}
          onDelete={(idx) => this.handleDelete('works', idx)}
        />
        {index < works.length - 1 && <div className="base-form__dividing" />}
      </React.Fragment>
    ));
  };

  renderOutWorks = () => {
    const { outOfWorks } = this.state;
    if (!outOfWorks) return null;
    return outOfWorks.map((item, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <React.Fragment key={outOfWorksKey + index}>
        <OutOfWorks
          data={item}
          index={index}
          getRef={(ref) => this.handleFetchRef('outOfWorks', ref)}
          onChange={this.handleOutOfWorksChange}
          onDelete={(idx) => this.handleDelete('outOfWorks', idx)}
        />
        {index < outOfWorks.length - 1 && <div className="base-form__dividing" />}
      </React.Fragment>
    ));
  };

  render() {
    const { resumeList, status, ifUpgrade } = this.state;
    return (
      <div className="workInfo">
        <Announcement
          title="请填写所有的正式工作经历（不含实习经历）。背调公司在电话征得你同意后才会开启背调，请放心填写。"
          type="warning"
          showIcon
        />
        <div className="workInfo__content">
          {this.renderFirstJob()}
          {this.renderLastJob()}
          {!status && (
            <>
              {this.renderWorks()}
              <span className="workInfo__add" onClick={() => this.handleAdd('works')}>
                <Icon type="add" />
                工作经历
              </span>
            </>
          )}
          <div className="base-form__title workInfo__out">
            歇业经历
            <span className="base-form__desc">
              （确保最近5年工作经历之间没有间隔，且工作经历不能有超过1个月的间隔，若有歇业经历请补充完整）
            </span>
          </div>
          {this.renderOutWorks()}
          <span className="workInfo__add" onClick={() => this.handleAdd('outOfWorks')}>
            <Icon type="add" />
            歇业经历
          </span>
          {/* @ts-expect-error */}
          {(window.checkTypeIndex !== 0 || (window.checkTypeIndex !== 3 && ifUpgrade)) && (
            <Resume onUpload={this.handleUpload} attachment={resumeList} />
          )}
        </div>
      </div>
    );
  }
}
export default WorkInfo;
